import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const d = typeof dateStr === "string" ? parseISO(dateStr) : dateStr;
    return format(d, "dd/MM/yyyy", { locale: it });
  } catch {
    return dateStr;
  }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "";
  try {
    const d = typeof dateStr === "string" ? parseISO(dateStr) : dateStr;
    return format(d, "dd/MM/yyyy HH:mm", { locale: it });
  } catch {
    return dateStr;
  }
}

export function formatEUR(val) {
  if (val == null || isNaN(val)) return "0,00 EUR";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(val);
}

export function todayISO() {
  return new Date().toISOString().split("T")[0];
}

export const STATUS_LABELS = {
  DRAFT: "Bozza",
  ISSUED: "Emesso",
  SUPERSEDED: "Sostituito",
  CANCELLED: "Annullato",
  ARCHIVED: "Archiviato",
};

export const STATUS_CLASSES = {
  DRAFT: "status-draft",
  ISSUED: "status-issued",
  SUPERSEDED: "status-superseded",
  CANCELLED: "status-cancelled",
  ARCHIVED: "status-archived",
};

export const DOC_TYPE_LABELS = {
  quote: "Preventivo",
  inventory: "Inventario",
  proforma: "Fattura Proforma",
};

export const CONDITION_OPTIONS = [
  { value: "nuovo", label: "Nuovo" },
  { value: "buono", label: "Buono" },
  { value: "usato", label: "Usato" },
  { value: "danneggiato", label: "Danneggiato" },
];

// Packing codes from Cavaliere Group standard
export const PACK_CODE_OPTIONS = [
  { value: "_none", label: "—" },
  { value: "CP", label: "CP - Imb. Trasportatore" },
  { value: "OP", label: "OP - Imb. Proprietario" },
  { value: "CD", label: "CD - Smontato Trasp." },
  { value: "OD", label: "OD - Smontato Propr." },
  { value: "PB", label: "PB - Libri Prof." },
  { value: "PP", label: "PP - Documenti Prof." },
  { value: "PE", label: "PE - Attrezz. Prof." },
];

// Detailed condition codes
export const CONDITION_DETAIL_OPTIONS = [
  { value: "_none", label: "—" },
  { value: "BR", label: "BR - Rotto" },
  { value: "BU", label: "BU - Bruciato" },
  { value: "CH", label: "CH - Scheggiato" },
  { value: "D", label: "D - Ammaccato" },
  { value: "F", label: "F - Sbiadito" },
  { value: "G", label: "G - Scavato" },
  { value: "L", label: "L - Allentato" },
  { value: "MI", label: "MI - Muffa" },
  { value: "MO", label: "MO - Tarmato" },
  { value: "R", label: "R - Sfregato" },
  { value: "RU", label: "RU - Arrugginito" },
  { value: "S", label: "S - Graffiato" },
  { value: "SO", label: "SO - Sporco" },
  { value: "T", label: "T - Strappato" },
  { value: "U", label: "U - Sconosciuta" },
  { value: "W", label: "W - Usurato" },
  { value: "Z", label: "Z - Incrinato" },
];

// Damage location codes
export const DEFAULT_VAT_RATE = 22; // IVA standard italiana
export const ITALIAN_PIVA_LENGTH = 11;
export const ITALIAN_CF_PIVA_MAX = 16;

export const DAMAGE_LOCATION_OPTIONS = [
  { value: "_none", label: "—" },
  { value: "1", label: "1 - Bracciolo" },
  { value: "2", label: "2 - Parte inf." },
  { value: "3", label: "3 - Angolo" },
  { value: "4", label: "4 - Fronte" },
  { value: "5", label: "5 - Sinistra" },
  { value: "6", label: "6 - Gamba" },
  { value: "7", label: "7 - Retro" },
  { value: "8", label: "8 - Destra" },
  { value: "9", label: "9 - Lato" },
  { value: "10", label: "10 - Sopra" },
  { value: "11", label: "11 - Impiallacciatura" },
  { value: "12", label: "12 - Bordo" },
];
